import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import CollapsibleSwitchListItem from '../../../../../../list-items/CollapsibleSwitchListItem';
import { BACKGROUND_REFLECTION_TYPE } from '../../../../Preview/PreviewDisplayConstants';

const BackdropReflectionToggleListItem = (props) => {
    const { backgroundReflectionType, updateBackgroundSettings } = props;

    const onReflectionToggle = (value) => updateBackgroundSettings({
        reflection: {
            type: value ? BACKGROUND_REFLECTION_TYPE.TWO_WAY : BACKGROUND_REFLECTION_TYPE.NONE,
            direction: 1
        }
    });

    return (
        <CollapsibleSwitchListItem
            checked={backgroundReflectionType == BACKGROUND_REFLECTION_TYPE.TWO_WAY || backgroundReflectionType == BACKGROUND_REFLECTION_TYPE.FOUR_WAY}
            text='Mirror Background'
            expansionEnabled={false}
            onChange={onReflectionToggle}
        />
    );
};

const mapStateToProps = (state) => {
    const { type: backgroundReflectionType } = state.createPreview.present.videoSettings.background.reflection;
    return { backgroundReflectionType }
}

const mapDispatchToProps = (dispatch) => {
    const updateBackgroundSettings = (properties) => dispatch(createActions.updateBackgroundSettings(properties));
    return { updateBackgroundSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackdropReflectionToggleListItem);